import { AppProvider } from "@/providers/app";
import { router } from "@/routes";
import { RouterProvider } from "react-router-dom";
import { RouteBlockerProvider } from "./hooks/blockerContext";
import { AuthProvider } from "./providers/auth";
import { ClarityProvider } from "./providers/clarityProvider";

export function App() {
  return (
    <AuthProvider>
      <AppProvider>
        <RouteBlockerProvider>
          <ClarityProvider>
            <RouterProvider router={router} />
          </ClarityProvider>
        </RouteBlockerProvider>
      </AppProvider>
    </AuthProvider>
  );
}
